import useAuth from 'hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';

type ProfileDropdownProps = {
  setIsOpen: (arg0: boolean) => void;
};

const ProfileDropDown = ({ setIsOpen }: ProfileDropdownProps) => {
  const { logoutAccount, user } = useAuth();
  const navigate = useNavigate();
  return (
    <div
      style={{ width: 260, marginTop: -8, marginRight: -25 }}
      className={'layout_header_profile_dropdown'}
    >
      <div
        className={'layout_header_task_dropdown_wrapper'}
        style={{
          padding: '17px 16px 20px 16px',
          margin: '10px 0px 0px 0px',
          borderBottom: '0.5px solid #73A1E7',
        }}
      >
        <div
          style={{ fontWeight: 600, color: '#000' }}
          className={'layout_header_menu_dropdown_menu'}
        >
          My account
        </div>
        <img
          onClick={() => setIsOpen(false)}
          src="/icons/close.svg"
          alt="close-icon"
          height={20}
          width={20}
          style={{ marginRight: '8px' }}
        />
      </div>
      {/* <Divider
        style={{ marginTop: '0px', marginBottom: '0px', color: '#73A1E7' }}
        orientation="left"
      /> */}
      <div
        className={'layout_header_profile_dropdown_info'}
        style={{ padding: '16px 0px 0px 0px' }}
      >
        <div className={'layout_header_profile_dropdown_info_header'}>
          <div style={{ marginLeft: 16 }}>
            <div style={{ color: '#000000', fontWeight: 600, width: '220px', overflow: 'hidden' }}>
              {user?.first_name} {user?.last_name}
            </div>
            {user?.role === 'admin' ? (
              <div style={{ color: '#28C696', fontSize: 12, fontWeight: 600 }}>
                Admin
              </div>
            ) : user?.role === 'service_manager' ? (
              <div style={{ color: '#28C696', fontSize: 12, fontWeight: 600 }}>
                Service Manager
              </div>
            ) : user?.role === 'department_manager' ? (
              <div style={{ color: '#28C696', fontSize: 12, fontWeight: 600 }}>
                Department Manager
              </div>
            ) : (
              <div style={{ color: '#28C696', fontSize: 12, fontWeight: 600 }}>
                Employee
              </div>
            )}
            <div style={{ color: '#000000', fontSize: 12, fontWeight: 400 }}>
              {user?.email}
            </div>
          </div>
        </div>
        <Link
          onClick={() => setIsOpen(false)}
          to={`/employee_directory/personal_data/${user?.id}`}
          className="layout_header_profile_dropdown_info_items has-text-black"
          style={{ padding: '9px 16px 9px 16px', marginTop: '13px' }}
        >
          <img src={'/icons/my_personal.svg'} alt={'item.name'} />
          <span style={{ color: '#000' }}>My Personal Space</span>
        </Link>

        <Link
          style={{ padding: '9px 16px 9px 16px' }}
          onClick={() => setIsOpen(false)}
          to={'/my_preference'}
          className={'layout_header_profile_dropdown_info_items has-text-black'}
        >
          <img src={'/icons/new_my_preference.svg'} alt={'/icons'} />
          <span style={{ color: '#000' }}>My Preferences</span>
        </Link>

        <Link
          style={{ padding: '9px 16px 9px 16px' }}
          onClick={() => setIsOpen(false)}
          to={'/change_password'}
          className={'layout_header_profile_dropdown_info_items has-text-black'}
        >
          <img src={'/icons/change_password.svg'} alt={'/icons'} />
          <span style={{ color: '#000' }}>Change Password</span>
        </Link>
        <div
          style={{ padding: '9px 16px 9px 16px' }}
          className={'layout_header_profile_dropdown_info_items has-text-black'}
          onClick={async () =>
            await logoutAccount()
              .then((res) => {
                if (res.status === 200) localStorage.removeItem('refresh');
                window.location.replace('/');
              })
              .catch((res) => {
                localStorage.removeItem('refresh');
                console.error(res);
              })
          }
        >
          <img alt={'/icons/new_signout.svg'} src={'/icons/new_signout.svg'} />
          <span style={{ color: '#000' }}>Sign Out</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileDropDown;
